import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '@nubank/nuds-web/components/Icon/Icon';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import SafeAnchorOffset from 'components/SafeAnchorOffset/SafeAnchorOffset';

import {
  IconWrapper, Panel, PanelBody, PanelHeader, PanelLink,
} from './style';

class CollapsePanel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
    };
  }

  handlePanelHeaderClick = () => {
    const { handleClick } = this.props;
    this.setState(state => ({
      collapsed: !state.collapsed,
    }));
    handleClick();
  };

  renderPanelHeading = children => (
    <Typography
      variant="subtitle"
      color="black"
      colorVariant="light"
      tag="h3"
    >
      {children}
    </Typography>
  );

  render() {
    const {
      title, body, id, rounded, shadow, className,
    } = this.props;
    const { collapsed } = this.state;

    // TODO: Remover acoplamento com do id com a página de perguntas
    return (
      <Panel className={className} rounded={rounded} shadow={shadow}>
        {id && <SafeAnchorOffset id={id} offsetTop="-120px" />}
        <PanelHeader onClick={this.handlePanelHeaderClick}>
          {id ? (
            <>
              <PanelLink href={`#${id}`}>
                {this.renderPanelHeading(title)}
              </PanelLink>
            </>
          ) : this.renderPanelHeading(title)}
          <IconWrapper>
            {!collapsed
              ? (<Icon name="minus" color="primary" />)
              : (<Icon name="plus" color="primary" />)}
          </IconWrapper>
        </PanelHeader>
        <PanelBody open={!collapsed}>
          <Typography tag="div">
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: body }} />
          </Typography>
        </PanelBody>
      </Panel>
    );
  }
}

CollapsePanel.defaultProps = {
  id: '',
  rounded: true,
  shadow: true,
  className: null,
  handleClick: () => {},
};

CollapsePanel.propTypes = {
  body: PropTypes.string.isRequired,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  id: PropTypes.string,
  rounded: PropTypes.bool,
  shadow: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default CollapsePanel;
